import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import Layout from '../views/layout/layout.vue'
Vue.use(Router)

export const initRoute = [
  {
		path: '/auth/:path?',
		component: () => import('@/views/auth'),
		name: 'Auth',
		meta: {
			name: '登录认证',
			// 不需要登录即可访问
			requiresAuth: false
		}
	},
  {
		path: '/',
		component: Layout, 
		redirect: 'order',
		name: 'orderList', 
		meta: {
			name: '订单管理',
			icon: 'searchOrigin',
		},
		children: [
			{
				path: '/order',
				name: 'order',
				component: () => import("@/views/order/list.vue"),
				meta: {
					name: '销售订单',
					icon: 'bar'
				},
				children: [
					
				]
			},{
				path: '/addOrder',
				name: 'addOrder',
				component: () => import("@/views/order/addOrder.vue"),
				meta: {
					name: '新增销售订单',
					icon: 'bar'
				},
			},
			{
				path: '/detail/:id', 
				name: 'Detail',
				component: () => import('@/views/order/detail.vue'), 
				props: true // 启用 props 接收参数（推荐方案）
			},
			{
				path: '/editOrder/:id', 
				name: 'EditOrder',
				component: () => import('@/views/order/editOrder.vue'), 
				props: true // 启用 props 接收参数（推荐方案）
			},
			{
				path: '/assOrder',
				name: 'assOrder',
				component: () => import("@/views/assemble/list.vue"),
				meta: {
					name: '组装订单',
					icon: 'bar'
				},
				children: [
					
				]
			},{
				path: '/addAssOrder',
				name: 'addAssOrder',
				component: () => import("@/views/assemble/addOrder.vue"),
				meta: {
					name: '新增组装订单',
					icon: 'bar'
				},
			},
			{
				path: '/AssDetail/:id', 
				name: 'AssDetail',
				component: () => import('@/views/assemble/detail.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '组装订单详情',
					icon: 'bar'
				},
			},
			{
				path: '/editAssOrder/:id', 
				name: 'EditAssOrder',
				component: () => import('@/views/assemble/editOrder.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '修改组装订单',
					icon: 'bar'
				},
			},
			{
				path: '/purOrder',
				name: 'purOrder',
				component: () => import("@/views/purchase/list.vue"),
				meta: {
					name: '请购订单',
					icon: 'bar'
				},
				children: [
					
				]
			},{
				path: '/addPurOrder',
				name: 'addPurOrder',
				component: () => import("../views/purchase/addOrder.vue"),
				meta: {
					name: '新增请购订单',
					icon: 'bar'
				},
				
			},
			{
				path: '/PurDetail/:id', 
				name: 'PurDetail',
				component: () => import('@/views/purchase/detail.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '修改请购订单',
					icon: 'bar'
				},
			},
			{
				path: '/editPurOrder/:id', 
				name: 'EditPurOrder',
				component: () => import('@/views/purchase/editOrder.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '修改请购订单',
					icon: 'bar'
				},
			},
			{
				path: '/outOrder',
				name: 'outOrder',
				component: () => import("@/views/outbound/list.vue"),
				meta: {
					name: '出库申请',
					icon: 'bar'
				},
			},
			{
				path: '/addOutOrder',
				name: 'addOutOrder',
				component: () => import("@/views/outbound/addOrder.vue"),
				meta: {
					name: '新增出库订单',
					icon: 'bar'
				},
			},
			{
				path: '/OutDetail/:id', 
				name: 'OutDetail',
				component: () => import('@/views/outbound/detail.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '出库订单详情',
					icon: 'bar'
				},
			},
			{
				path: '/editOutOrder/:id', 
				name: 'EditOutOrder',
				component: () => import('@/views/outbound/editOrder.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '修改出库订单',
					icon: 'bar'
				},
			},
			{
				path: '/sfOrder',
				name: 'sfOrder',
				component: () => import("@/views/sfbound/list.vue"),
				meta: {
					name: '顺丰下单',
					icon: 'bar'
				},
			},
			{
				path: '/addSfOrder',
				name: 'addSfOrder',
				component: () => import("@/views/sfbound/addOrder.vue"),
				meta: {
					name: '新增顺丰下单',
					icon: 'bar'
				},
			},
			{
				path: '/SfDetail/:id', 
				name: 'SfDetail',
				component: () => import('@/views/sfbound/detail.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '顺丰下单详情',
					icon: 'bar'
				},
			},
			{
				path: '/editSfOrder/:id', 
				name: 'EditSfOrder',
				component: () => import('@/views/sfbound/editOrder.vue'), 
				props: true, // 启用 props 接收参数（推荐方案）
				meta: {
					name: '修改顺丰下单',
					icon: 'bar'
				},
			},
			{				path: '/sfMyAddress',				
				name: 'sfMyAddress',				
				component: () => import("@/views/sfbound/myAddress.vue"),				
				meta: {					name: '我的地址',					icon: 'bar'				},			},
			{
				path: '/sfShippingAddress',
				name: 'sfShippingAddress',
				component: () => import("@/views/sfbound/shippingAddress.vue"),
				meta: {
					name: '发货地址',
					icon: 'bar'
				},
			},
			{
				path: '/sfCompanyAddress',
				name: 'sfCompanyAddress',
				component: () => import("@/views/sfbound/companyAddress.vue"),
				meta: {
					name: '公司地址',
					icon: 'bar'
				},
			},
			{
				path: '/sfPrinterNickname',
				name: 'sfPrinterNickname',
				component: () => import("@/views/sfbound/printerNickname.vue"),
				meta: {
					name: '打印机昵称管理',
					icon: 'bar'
				},
			},
			{
				path: '/sfPrintServerList',
				name: 'sfPrintServerList',
				component: () => import("@/views/sfbound/serverList.vue"),
				meta: {
					name: '打印服务器列表',
					icon: 'bar'
				},
			},
			{
				path: '/sfSetConfig',
				name: 'sfSetConfig',
				component: () => import("@/views/sfbound/setConfig.vue"),
				meta: {
					name: '设置参数',
					icon: 'bar'
				},
			},
			{
				path: '/penaltyQuery',
				name: 'penaltyQuery',
				component: () => import("@/views/penaltyQuery/list.vue"),
				meta: {
					name: '罚息查询',
					icon: 'bar'
				},
			},
			{
				path: '/salesmanAnalysis',
				name: 'salesmanAnalysis',
				component: () => import("@/views/penaltyQuery/salesmanAnalysis.vue"),
				meta: {
					name: '员工分析',
					icon: 'bar'
				},
			},
			{
				path: '/taskConfig',
				name: 'taskConfig',
				
				component: () => import("@/views/penaltyQuery/taskConfig.vue"),
				meta: {
					name: '任务参数配置',
					icon: 'bar'
				},
			},
			{
				path: '/taskLog',
				name: 'taskLog',
				component: () => import("@/views/penaltyQuery/taskLog.vue"),
				meta: {
					name: '任务执行日志',
					icon: 'bar'
				},
			},
			{
				path: '/syncTask',
				name: 'syncTask',
				component: () => import("@/views/penaltyQuery/syncTask.vue"),
				meta: {
					name: '同步任务管理',
					icon: 'bar'
				},
			},
			{
				path: '/superReport',
				name: 'superReport',
				component: () => import("@/views/superReport/report.vue"),
				meta: {
					name: '超聚变上报',
					icon: 'bar'
				},
			},
			
					{
					path: '/sn/list',
					name: 'snList',
					component: () => import("@/views/sn/list.vue"),
					meta: {
						name: '序列号库存查询',
						icon: 'bar'
					},
				},
				{
					path: '/sn/productList',
					name: 'productList',
					component: () => import("@/views/sn/productList.vue"),
					meta: {
						name: '物料清单查询',
						icon: 'bar'
					},
				},
				{
					path: '/sn/inventoryList',
					name: 'inventoryList',
					component: () => import("@/views/sn/inventoryList.vue"),
					meta: {
						name: '库存查询',
						icon: 'bar'
					},
				},
					{
					path: '/sn/add',
					name: 'addSn',
					component: () => import("@/views/sn/add.vue"),
					meta: {
						name: '添加 SN 号',
						icon: 'bar'
					},
				},
				{
					path: 'test',
					name: 'snTest',
					component: () => import("@/views/sn/test.vue"),
					meta: {
						name: '测试页面',
						icon: 'bar'
					},
				}
				,
		]
	},
]

const createRouter = () => new Router({ 
  routes: initRoute
});

/* 重置路由，用于每次配置完刷新路由重置 */
export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

/* 初始路由 */
let router = createRouter()
 
// router.beforeEach((to, from, next) => {
  // if (!store.state.UserMessage) { 
  //   if (to.matched.length > 0 && !to.matched.some(record => record.meta.requiresAuth)) {
  //     next()
  //   } else { 
  //     next({ path: '/login' }) 
  //   }
  // } else {  
    // if (!store.state.sideBarMenu.sidebarMenu) {
    //   store.dispatch('sideBarMenu/SET_SIDEBAR_MENU').then(() => {
    //     next({ path: to.path })
    //   })
    // } else {
		// 	next()
    // }
  // } 
// })

router.afterEach((to, from, next) => {
	if(to.name == "reportResults") return ;
	let matched = [];
	var routerList = to.matched
	routerList.forEach((item)=>{
		matched.push({
			path: item.path,
			name: item.meta.name,
		})
	})
	store.commit('setBreadcrumb',matched)
  store.commit('sideBarMenu/SET_CURRENT_MENU', to.name)
})

/**
 * 重写路由的push方法,多次重复push一个路由会报错
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default router

